import React from "react";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet-async";

import { Button as MuiButton, Typography } from "@material-ui/core";
import { spacing } from "@material-ui/system";

const Button = styled(MuiButton)(spacing);

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(6)}px;
  text-align: center;
  background: transparent;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)}px;
  }
`;

function Page404() {
  return (
    <Wrapper>
      <Helmet title="Erro 404" />
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        404
      </Typography>
      <Typography component="h2" variant="h5" align="center" gutterBottom>
        Página não encontrada.
      </Typography>
      <Typography component="h2" variant="body1" align="center" gutterBottom>
        A página que você está tentando acessar pode ter sido removida ou você
        não tem acesso.
      </Typography>

      <Button
        component={Link}
        to="/login"
        variant="contained"
        color="secondary"
        mt={2}
      >
        Voltar à TMX
      </Button>
    </Wrapper>
  );
}

export default Page404;
